import script from "./ellipsis.vue?vue&type=script&setup=true&lang=js"
export * from "./ellipsis.vue?vue&type=script&setup=true&lang=js"

import "./ellipsis.vue?vue&type=style&index=0&id=0adda58f&lang=scss&scoped=true"
import "./ellipsis.vue?vue&type=style&index=1&id=0adda58f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0adda58f"]])

export default __exports__